import { render, staticRenderFns } from "./drawer-component.vue?vue&type=template&id=837f3422&scoped=true"
import script from "./drawer-component.vue?vue&type=script&lang=js"
export * from "./drawer-component.vue?vue&type=script&lang=js"
import style0 from "./drawer-component.vue?vue&type=style&index=0&id=837f3422&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "837f3422",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('837f3422')) {
      api.createRecord('837f3422', component.options)
    } else {
      api.reload('837f3422', component.options)
    }
    module.hot.accept("./drawer-component.vue?vue&type=template&id=837f3422&scoped=true", function () {
      api.rerender('837f3422', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/compoment/drawer-component/drawer-component.vue"
export default component.exports